import React, {useEffect, useMemo, useState} from "react";

/** English promotional copy supplied by the website owner. */
const HEADING = "Discover DEAR LANGUAGE – GERMAN A1–C2,";
const DESCRIPTION =
  "your all-in-one platform for learning German with interactive lessons, AI conversations, practice exams, and much more.";
const INVITATION =
  "Join our step-by-step German courses today and start your journey towards speaking German confidently!";

/**
 * One restrained headline reveal when the Home page loads.
 * The complete heading remains available to assistive technology at all times;
 * its invisible measure prevents any changes in layout while typing.
 */
const HeroMarketingIntro: React.FC = () => {
  const characters = useMemo(() => Array.from(HEADING), []);
  const [reducedMotion, setReducedMotion] = useState(() =>
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches,
  );
  const [visibleCount, setVisibleCount] = useState(() =>
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ? characters.length
      : 0,
  );

  useEffect(() => {
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setReducedMotion(media.matches);
    update();
    media.addEventListener?.("change", update);
    return () => media.removeEventListener?.("change", update);
  }, []);

  useEffect(() => {
    if (reducedMotion) {
      setVisibleCount(characters.length);
      return;
    }
    let index = 0;
    let interval: number | undefined;
    const initialDelay = window.setTimeout(() => {
      interval = window.setInterval(() => {
        index += 1;
        setVisibleCount(Math.min(index, characters.length));
        if (index >= characters.length && interval !== undefined) {
          window.clearInterval(interval);
        }
      }, 38);
    }, 240);
    return () => {
      window.clearTimeout(initialDelay);
      if (interval !== undefined) window.clearInterval(interval);
    };
  }, [characters, reducedMotion]);

  return (
    <div className="dlx-hero-marketing" lang="en" data-site-no-translate="true">
      <span className="dlx-hero-marketing-label" aria-hidden="true">
        LEARN GERMAN · A1 TO C2
      </span>
      <h1 className="dlx-hero-marketing-heading" id="dlx-main-heading" aria-label={HEADING}>
        <span className="dlx-hero-marketing-measure" aria-hidden="true">{HEADING}</span>
        <span className="dlx-hero-marketing-typed" aria-hidden="true">
          {characters.slice(0, visibleCount).join("")}
          <span className={`dlx-hero-marketing-caret ${visibleCount >= characters.length ? "is-complete" : ""}`} />
        </span>
      </h1>
      <p className="dlx-hero-marketing-description">{DESCRIPTION}</p>
      <p className="dlx-hero-marketing-invitation">{INVITATION}</p>
    </div>
  );
};

export default HeroMarketingIntro;
